// tslint:disable: no-unused-expression
import { Component, AfterViewInit, OnDestroy } from '@angular/core';

import { CallApiMethodsService } from 'src/app/services/AsynchronousRequestServices/call-api-methods.service';
import { GetCurrentThemeService } from 'src/app/services/TemplateServices/get-current-theme.service';
import { UserInformationService } from 'src/app/services/TemplateServices/user-information.service';

import { THEMEVALUES } from "src/app/constants/themes";

@Component({
  templateUrl: './dropdown-logout.component.html',
  styleUrls: ["./navbar.component.scss"],
  selector: 'app-dropdown-logout',
})
export class DropdownLogoutComponent implements AfterViewInit, OnDestroy {

  constructor(
    private getCurrentThemeService: GetCurrentThemeService,
    private callApiMethod: CallApiMethodsService,
    public user: UserInformationService,
  ) { }

  // themes: Guarda los nombres de cada tema
  themes: string[] = Object.keys(THEMEVALUES);

  ngAfterViewInit() {
    // ↓↓ Inicia las configuraciones de materializecss
    const tooltip: NodeListOf<HTMLElement> = document.querySelectorAll('.tooltipped-logout');
    M.Tooltip.init(tooltip, {});
  }

  /* themify(): Método que actualiza el tema de la página
    data: Tema seleccionado
  */
  themify(data: string) {
    // ↓ Actualiza el tema en el storage
    localStorage.setItem("theme", data);
    // ↓ Actualiza el tema seleccionado en el servicio de temas
    this.getCurrentThemeService.setTheme(data);
    // ↓ Aplica el tema a la página
    (document.querySelector("html") as HTMLElement).setAttribute("theme", data);
  }

  /* themifyTemplate()  Método que actualiza el fondo de las cabeceras
    data: Fondo seleccionado
  */
  themifyTemplate(data: string) {
    // ↓ Veririca si el fondo seleccionado es diferente al actual
    if (localStorage.getItem("color-templates") !== data) {
      // ↓ Actualiza el fondo en el storage
      localStorage.setItem("color-templates", data);
      // ↓↓ Actualiza el fondo en el servicio de temas
      this.getCurrentThemeService.tagStyle = data;
      this.getCurrentThemeService.setTheme();
    }
  }

  // updateCredentials(): Método que actualiza la Información del usuario
  updateCredentials = () => window.location.assign(`?u=${this.user.userToken}&p=${this.user.platform}`);

  // logOut() Método que cierra la sesión del usuario
  logOut() {
    // ↓* Destruye la sesión en bd y redirecciona a la página principal de GC
    this.callApiMethod.sendAsynchronousRequest("users", "logOut").finally(() => {
      // ↓ Elimina la información de usuario del storage
      ["dashboard", "entity", "nav", "user", "mods", "alerts"].forEach((elm: string) => window.localStorage.removeItem(elm));
      const link: HTMLAnchorElement = document.createElement('a'); link.href = "https://garantiascomunitarias.com";
      document.body.appendChild(link); link.click(); link.remove();
    });
  }

  ngOnDestroy() {
    // ↓ Destruye las instancias de materializecss
    document.querySelectorAll('.tooltipped-logout').forEach((elm: Element) => M.Tooltip.getInstance(elm) ? M.Tooltip.getInstance(elm).destroy() : null);
  }
}
